import Component from './components/PaymentComplements';
import { PATH } from './constants';

export { PATH };
export default Component;
